import { css } from 'styled-components';

import type { ButtonStyleProps } from '/shared/components/widgets/button/buttonTypes';
import Colours from '/shared/styled/Colours';

export default function loadingStyle({
  $isLoading = false,
  $primary = false,
  $outline = false,
  $inverted = false,
  $dark = false,
}: ButtonStyleProps) {
  if (!$isLoading) {
    return;
  }

  const shouldUseDisabledBackground = $primary && !$outline && !$inverted && !$dark;

  return css`
    position: relative;
    opacity: 1;

    &:hover,
    &:focus,
    &:active {
      opacity: 1;
    }

    > div:first-child {
      opacity: 0.08;
    }

    ${
      shouldUseDisabledBackground &&
      css`
        background: ${Colours.greenLight2};

        &:hover,
        &:focus,
        &:active {
          background: ${Colours.greenLight2};
        }
      `
    }
  `;
}
